module.exports = __webpack_public_path__ + "static/media/best.e845b2e0.svg";